import { toWSDateString, WSAlert } from "@wingspanhq/fe-component-library";
import { PayableStatus } from "@wingspanhq/wingspan-api-sdk";
import { useHistory } from "react-router-dom";
import { queriesPayableRows } from "@query";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";

interface Props {
  payeeId: string;
}

const payableStatusToSentenceMap: Partial<Record<PayableStatus, string>> = {
  [PayableStatus.CANCELLED]: "A cancelled",
  [PayableStatus.CREATED]: "A draft",
  [PayableStatus.OPENED]: "An open",
  [PayableStatus.PAID]: "A paid",
  [PayableStatus.PAYMENT_IN_TRANSIT]: "A payment in transit",
  [PayableStatus.PENDING]: "A pending"
};

export const AlertExistingPayable: React.FC<Props> = props => {
  const history = useHistory();

  const queryPayables = queriesPayableRows.searchPayableRows.useQuery({
    filter: {
      metadata_invoiceType: { ne: "approvedInvoicesPayment" },
      metadata_creationSource: { ne: "personalPaylink" },
      payeeId: { eq: props.payeeId },
      status: {
        anyOf: [
          PayableStatus.CREATED,
          PayableStatus.OPENED,
          PayableStatus.PENDING
        ]
      }
    },
    page: {
      size: 1
    }
  });
  // The contractor's name comes off the payable row this alert is about, which
  // carries the counterparty profile — no second read, and the same string the
  // payables table shows. The alert's job is to warn about the duplicate, so a
  // row with no name still renders; it just names nobody.
  const payable = queryPayables.data?.data?.[0];

  if (!payable || !payable.status) {
    return null;
  }

  return (
    <WSAlert
      mt="L"
      theme="warning"
      action={{
        text: "Edit payable",
        onClick: () => {
          history.push(`/member/invoices/payables/${payable.id}/edit`);
        }
      }}
    >
      {payableStatusToSentenceMap[payable.status]} payable exists to{" "}
      {selectorSearchRowName(payable)} due{" "}
      {toWSDateString(payable.dueDate, "monthDayYear")}.
    </WSAlert>
  );
};
